/** True when a repeating group has more instances than its required minimum. */
export const canRemoveGroupInstance = (
  totalCount: number,
  minItems?: number,
): boolean => totalCount > (minItems ?? 1);
